import { render, staticRenderFns } from "./WineListShare.vue?vue&type=template&id=6a80d073&"
import script from "./WineListShare.vue?vue&type=script&lang=js&"
export * from "./WineListShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports